import { useState, forwardRef, useRef } from 'react'
import { genderIcons, dateFormats } from 'app/constants'
import { getAgeFromDob, format } from 'utils/datetime'
import { useOnClickOutside, useToggle } from 'hooks'
import ContextMenu from 'components/ContextMenu'
import { ListItem, TitleStack, TitleStackMetaItem, TooltipDirective } from 'components/Zui'
import './index.css'

const PatientsListItem = (
    {
        patient,
        onClick,
        selectedPatient,
        contextMenu,
        handleSharePatient,
        handleAddTag,
        handleDownload,
        handleDelete,
        handleAddPatientFiles,
    },
    ref
) => {
    const { isOpen, onClose, onToggle } = useToggle(false)
    const [pageEnd, setPageEnd] = useState(false)
    const GenderIcon = genderIcons[patient.gender || 'unknown']

    const myRef = useRef(null)
    useOnClickOutside(myRef, onClose, patient.patientId)

    const menu = contextMenu?.map(m => {
        if (m.id === 'delete') m.onClick = () => handleDelete(patient.id)
        if (m.id === 'share') m.onClick = () => handleSharePatient(patient)
        if (m.id === 'tag') m.onClick = () => handleAddTag(patient.id)
        if (m.id === 'download') m.onClick = () => handleDownload(patient.id)
        if (m.id === 'move') m.onClick = () => handleAddPatientFiles(patient.id)
        return m
    })

    return (
        <div className="patient-list-item-wrap" style={{ position: 'relative' }} ref={ref}>
            <ListItem
                size="l"
                onClick={() => onClick(patient)}
                emphasis={selectedPatient?.id === patient.id ? 'active' : 'default'}
                hierarchy="first"
                style={{ paddingLeft: '32px', height: '72px', overflow: 'hidden' }}
            >
                <div className="patient-title-stack">
                    <TitleStack
                        size="xs"
                        wrapping={false}
                        className="custom-zui-title-stack-patient"
                    >
                        <h2 aria-describedby="tooltip">
                            {patient.name}
                            <TooltipDirective delayed id="tooltip" trigger={['hover']}>
                                <zui-tooltip>{patient.name}</zui-tooltip>
                            </TooltipDirective>
                        </h2>
                        <GenderIcon slot="icon" size="s" />
                        <TitleStackMetaItem slot="meta" style={{ display: 'inline-block' }}>
                            {format(patient.dateOfBirth, dateFormats.dob)} (
                            {getAgeFromDob(patient.dateOfBirth) || 1})
                        </TitleStackMetaItem>
                        <TitleStackMetaItem slot="meta" style={{ display: 'inline-block' }}>
                            {patient.patientId}
                        </TitleStackMetaItem>
                    </TitleStack>
                </div>
            </ListItem>
            {contextMenu && contextMenu.length > 0 && (
                <div
                    data-ref={patient.patientId}
                    className="context-menu-icon"
                    onClick={e => {
                        if (window.innerHeight > 700) {
                            if (e.view.innerHeight - e.screenY < 400) {
                                setPageEnd(true)
                                onToggle()
                            } else {
                                setPageEnd(false)
                                onToggle()
                            }
                        }
                        if (window.innerHeight > 400 && window.innerHeight < 700) {
                            if (e.view.innerHeight - e.screenY < 100) {
                                setPageEnd(true)
                                onToggle()
                            } else {
                                setPageEnd(false)
                                onToggle()
                            }
                        }
                    }}
                >
                    <div
                        className={`${isOpen && 'opened-context-menu'} btn-context`}
                        data-ref={patient.patientId}
                    >
                        <zui-icon-common-more-centered
                            data-ref={patient.patientId}
                            style={{ color: '#626C7A' }}
                        ></zui-icon-common-more-centered>
                    </div>
                </div>
            )}
            {isOpen && contextMenu && (
                <ContextMenu
                    ref={myRef}
                    onClick={onClose}
                    className={pageEnd ? ['context-menu-last-item'] : []}
                    options={menu}
                />
            )}
        </div>
    )
}

export default forwardRef(PatientsListItem)
